import styled from 'styled-components';
import { media } from './common-data';

export const MainContainer = styled.div.withConfig({
  shouldForwardProp: (prop) =>
    !["backgroundColor"].includes(prop),
})<{
  backgroundColor?: string;
}>`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center; /* 아이템을 수평으로 중앙 정렬 */
  align-items: center; /* 아이템을 수직으로 중앙 정렬 */
  background-color: ${({ backgroundColor }) => backgroundColor || 'transparent'}; /* backgroundColor 값이 있으면 그 값을 사용하고, 없으면 투명색 */

//   background: lightgray;

  ${media.mobile`
    // background-color: red;
  `}

  ${media.tablet`
    // background-color: blue;
  `}

  ${media.desktop`
    // background-color: lightgreen;
  `}
`;


export const AuthBox = styled.div<{
    backgroundColor?: string; // 배경색을 받을 수 있는 prop 추가
}>`
  background-color: ${({ backgroundColor }) => backgroundColor || 'white'}; /* backgroundColor 값이 있으면 그 값을 사용하고, 없으면 white */
  padding: 40px;
  border-radius: 20px; /* 모서리 둥글게 */
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1); /* 그림자 추가 */
  width: 100%;
`;


export const VerticalLayout = styled.div.withConfig({
  shouldForwardProp: (prop) =>
    !["paddingTop", "paddingRight", "paddingBottom", "paddingLeft", "backgroundColor", "wrapContents"].includes(prop),
})<{
  width?: string | number;
  height?: string | number;
  paddingTop?: string | number;
  paddingRight?: string | number;
  paddingBottom?: string | number;
  paddingLeft?: string | number;
  backgroundColor?: string;
  wrapContents?: boolean;  // wrapContents prop 추가
}>`
  display: flex;
  flex-direction: column;  /* 세로 방향으로 배치 */
  align-items: start;
  justify-content: flex-start;
  text-align: start;
  box-sizing: border-box;
  width: ${({ width }) => (width ? (typeof width === 'number' ? `${width}px` : width) : '100%')};
  height: ${({ wrapContents, height }) => wrapContents ? 'auto' : (height ? (typeof height === 'number' ? `${height}px` : height) : '100%')};  /* wrapContents가 true일 때 height: auto */
  padding-top: ${({ paddingTop }) => (paddingTop ? (typeof paddingTop === 'number' ? `${paddingTop}px` : paddingTop) : '0')};
  padding-right: ${({ paddingRight }) => (paddingRight ? (typeof paddingRight === 'number' ? `${paddingRight}px` : paddingRight) : '0')};
  padding-bottom: ${({ paddingBottom }) => (paddingBottom ? (typeof paddingBottom === 'number' ? `${paddingBottom}px` : paddingBottom) : '0')};
  padding-left: ${({ paddingLeft }) => (paddingLeft ? (typeof paddingLeft === 'number' ? `${paddingLeft}px` : paddingLeft) : '0')};
  background-color: ${({ backgroundColor }) => backgroundColor || 'transparent'};
`;


export const HorizontalLayout = styled.div.withConfig({
  shouldForwardProp: (prop) =>
    ![
      "paddingTop",
      "paddingRight",
      "paddingBottom",
      "paddingLeft",
      "backgroundColor",
      "wrapContents",
      "alignItems", // ✅ 추가
    ].includes(prop),
})<{
  width?: string | number;
  height?: string | number;
  paddingTop?: string | number;
  paddingRight?: string | number;
  paddingBottom?: string | number;
  paddingLeft?: string | number;
  backgroundColor?: string;
  wrapContents?: boolean;
  alignItems?: string; // ✅ center 정렬을 위한 속성 추가
}>`
  display: flex;
  flex-direction: row;
  align-items: ${({ alignItems }) => alignItems || 'flex-start'};  /* ✅ 적용 */
  justify-content: flex-start;
  text-align: start;
  box-sizing: border-box;
  width: ${({ wrapContents, width }) =>
    wrapContents ? 'auto' : (width ? (typeof width === 'number' ? `${width}px` : width) : '100%')};
  height: ${({ height }) => (height ? (typeof height === 'number' ? `${height}px` : height) : '100%')};
  padding-top: ${({ paddingTop }) => (paddingTop ? (typeof paddingTop === 'number' ? `${paddingTop}px` : paddingTop) : '0')};
  padding-right: ${({ paddingRight }) => (paddingRight ? (typeof paddingRight === 'number' ? `${paddingRight}px` : paddingRight) : '0')};
  padding-bottom: ${({ paddingBottom }) => (paddingBottom ? (typeof paddingBottom === 'number' ? `${paddingBottom}px` : paddingBottom) : '0')};
  padding-left: ${({ paddingLeft }) => (paddingLeft ? (typeof paddingLeft === 'number' ? `${paddingLeft}px` : paddingLeft) : '0')};
  background-color: ${({ backgroundColor }) => backgroundColor || 'transparent'};
`;


export const FrameLayout = styled.div<{
  width?: string | number;  // width 값은 string 또는 number로 받을 수 있도록 설정
  height?: string | number; // height 값도 string 또는 number로 받을 수 있도록 설정
  backgroundColor?: string; // 배경색을 받을 수 있는 prop 추가
}>`
  position: relative; /* 자식 요소를 절대 위치로 배치할 수 있도록 설정 */
  width: ${({ width }) => (width ? (typeof width === 'number' ? `${width}px` : width) : '100%')}; /* width 값이 있으면 그 값을 사용하고, 없으면 100% */
  height: ${({ height }) => (height ? (typeof height === 'number' ? `${height}px` : height) : '100%')}; /* height 값이 있으면 그 값을 사용하고, 없으면 100% */
  background-color: ${({ backgroundColor }) => backgroundColor || 'transparent'}; /* backgroundColor 값이 있으면 그 값을 사용하고, 없으면 투명색 */
`;

export const FrameChild = styled.div<{
    top?: string | number;      // top 값은 string 또는 number로 받을 수 있도록 설정
    left?: string | number;     // left 값도 string 또는 number로 받을 수 있도록 설정
    right?: string | number;    // right 값도 string 또는 number로 받을 수 있도록 설정
    bottom?: string | number;   // bottom 값도 string 또는 number로 받을 수 있도록 설정
    width?: string | number;    // width 값은 string 또는 number로 받을 수 있도록 설정
    height?: string | number;   // height 값도 string 또는 number로 받을 수 있도록 설정
    backgroundColor?: string;   // 배경색을 받을 수 있는 prop 추가
  }>`
    position: absolute; /* 부모(FrameLayout)를 기준으로 위치 지정 */
    top: ${({ top }) => (top !== undefined ? (typeof top === 'number' ? `${top}px` : top) : 'auto')};
    left: ${({ left }) => (left !== undefined ? (typeof left === 'number' ? `${left}px` : left) : 'auto')};
    right: ${({ right }) => (right !== undefined ? (typeof right === 'number' ? `${right}px` : right) : 'auto')};
    bottom: ${({ bottom }) => (bottom !== undefined ? (typeof bottom === 'number' ? `${bottom}px` : bottom) : 'auto')};
    width: ${({ width }) => (width !== undefined ? (typeof width === 'number' ? `${width}px` : width) : 'auto')};
    height: ${({ height }) => (height !== undefined ? (typeof height === 'number' ? `${height}px` : height) : 'auto')};
    background-color: ${({ backgroundColor }) => backgroundColor || 'transparent'}; /* backgroundColor 값이 있으면 그 값을 사용하고, 없으면 투명색 */
  `;